import React from "react";
import allImgPaths from "assets/images";
import useAppState from "context/useAppState";

interface Iprops {
  isShow: boolean,
  openMaximizeModal: () => void;
  chartName?: any;
  downloadChartName?: any
}

const InsightCardsOptions = ({ isShow, openMaximizeModal, chartName, downloadChartName }: Iprops) => {
  const {
    showInsight,
    setState,
    openPlanningAnimation,
    showChatbox,
    downloadChart
  } = useAppState("eventData");

  const {
    cardAnimation,
    setState: setCardWrapperState
  } = useAppState('cardWrapper');

  return (
    <>
      <div className={`${isShow ? "block" : "hidden"} absolute w-60 bg-white top-full -right-6 border border-[#EAECF0] rounded-lg z-10 shadow-customShadow7 overflow-hidden mt-0.5`}>
        <ul className=''>
          <li className='flex items-center gap-x-2 py-3.5 px-4 border-b border-[#EAECF0] hover:text-[#1e0af5] custom-group-hover'
            onClick={() => {
              setState({ openPlanningAnimation: true, showChatbox: true, showInsight: true });
              setCardWrapperState({ cardAnimation: false });
            }}>
            <img
              className='w-4 h-4 group-hover-child'
              src={allImgPaths.EditIcon}
              alt='Edit Icon'
            />
            <span>Edit</span>
          </li>
          <li className='flex items-center gap-x-2 py-3.5 px-4 border-b border-[#EAECF0] hover:text-[#1e0af5] custom-group-hover'>
            <img className='group-hover-child' src={allImgPaths.MoveIcon} alt='' />
            <span>Move</span>
          </li>
          <li className='flex items-center gap-x-2 py-3.5 px-4 border-b border-[#EAECF0] hover:text-[#1e0af5] custom-group-hover'>
            <img className='w-4 h-4 group-hover-child' src={allImgPaths.ResizeIcon} alt='' />
            <span>Resize</span>
          </li>
          <li className='flex items-center gap-x-2 py-3.5 px-4 border-b border-[#EAECF0] hover:text-[#1e0af5] custom-group-hover' onClick={openMaximizeModal}>
            <img className='group-hover-child' src={allImgPaths.MaximizeIcon} alt='' />
            <span>Maximize</span>
          </li>
          {
            chartName &&
            <li className='flex items-center gap-x-2 py-3.5 px-4 border-b border-[#EAECF0] hover:text-[#1e0af5] custom-group-hover'
              onClick={() => {
                setState({ downloadChart: true, chartName, downloadChartName });
              }}>
              <img className='w-5 h-5 -ml-1 group-hover-child' src={allImgPaths.downloadIcon} alt='' />
              <span>Download</span>
            </li>
          }
        </ul>
      </div>
    </>
  );
};

export default InsightCardsOptions;
